import { useState } from "react";
import { Button } from "../components/ui/button";
import { ChevronDown } from "lucide-react";

const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

const FAQItem = ({ question, answer, isOpen, onClick }) => (
  <div className="bg-white rounded-xl border border-[#FFE4CC] overflow-hidden mb-3">
    <button
      className="w-full text-left font-semibold text-[#1A1C19] p-5 flex items-center justify-between hover:bg-[#FFF9F5] transition-colors"
      onClick={onClick}
    >
      <span className="pr-4">{question}</span>
      <ChevronDown 
        size={20} 
        className={`text-[#FF6B00] transition-transform duration-200 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} 
      />
    </button>
    {isOpen && (
      <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
        <div className="text-[#4A5043] leading-relaxed px-5 pb-5 border-t border-[#FFE4CC] pt-4 bg-[#FFF9F5] cursor-pointer hover:bg-[#FFF0E0] transition-colors">
          {answer}
        </div>
      </a>
    )}
  </div>
);

export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Is this right for me?",
      answer: "If you're struggling with stubborn weight, low energy, or a sluggish metabolism — especially after 40 — this was made for you. It's designed for both men and women who want a natural way to support healthier metabolic function and overall vitality. Click here to learn more and see if it's right for you.",
    },
    {
      question: "Is this safe?",
      answer: "This is a natural, proprietary formula crafted in the USA. It's manufactured in an FDA-registered and GMP-certified facility using state-of-the-art, precision-engineered machinery under the strictest sterile standards. Every ingredient is 100% plant-based, soy-free, dairy-free, and non-GMO. Click here to see the full ingredient list.",
    },
    {
      question: "How many bottles should I order?",
      answer: "We recommend starting with the 6-bottle package for the best results and value. Most customers experience noticeable changes after 6-12 weeks of consistent use. Plus, 6-bottle orders come with free shipping and bonuses. Click here to see the pricing options.",
    },
    {
      question: "What's the best way to take it?",
      answer: "Take 1 easy-to-swallow capsule daily with a full glass of water, ideally in the morning before breakfast. Consistency is key — take it daily for the best metabolic support. Click here to order now.",
    },
    {
      question: "Is this a one-time payment?",
      answer: "Yes! There are no hidden charges, subscriptions, or automatic re-bills. You make a one-time purchase and that's it. Click here to place your secure order.",
    },
    {
      question: "What if it doesn't work for me?",
      answer: "We stand behind this with a 180-day money-back guarantee. If you're not thrilled with your results, just contact customer support for a full refund. No questions asked. Click here to try it risk-free.",
    },
  ];

  return (
    <section id="faq" data-testid="faq-section" className="py-16 md:py-20 bg-[#F9F7F2]" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" className="block">
          <div className="text-center mb-10 cursor-pointer">
            <span className="inline-block bg-[#FFF5E6] text-[#FF6B00] text-xs font-bold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
              Got Questions?
            </span>
            <h2 id="faq-heading" className="text-3xl md:text-4xl lg:text-5xl font-black text-[#1A1C19] mb-4" style={{ fontFamily: "Fraunces, serif" }}>
              Frequently Asked Questions
            </h2>
          </div>
        </a>

        <div>
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
            />
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-[#73786F] mb-4">Ready to start your transformation?</p>
          <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer" data-testid="faq-cta">
            <Button className="bg-gradient-to-r from-[#FF6B00] to-[#FF8C00] hover:from-[#E65C00] hover:to-[#FF6B00] text-white font-bold rounded-full px-8 py-4 shadow-lg hover:shadow-xl transition-all duration-300">
              👉 Yes! I Want To Try This
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
